document.addEventListener("DOMContentLoaded", () => {

  const prepaid = document.getElementById("rxnPrepaidDate");
  const cod = document.getElementById("rxnCodDate");

  if (!prepaid || !cod) return;

  // Prepaid
  prepaid.textContent = "3–5 Days";

  // COD
  cod.textContent = "7–10 Days";

});


/*=========================================
RXN Accordion
=========================================*/

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".rxn-fulfilled").forEach(function(wrapper){

    const toggle = wrapper.querySelector(".rxn-fulfilled-toggle");

    if(!toggle) return;

    toggle.addEventListener("click", function(){

      wrapper.classList.toggle("active");

      toggle.setAttribute(
        "aria-expanded",
        wrapper.classList.contains("active")
      );

    });

  });

});